import { Navigate, Outlet, useLocation } from "react-router-dom";
import useAuth from "@/hooks/useAuth";
import { useAppSelector } from "@/store/store";

const ProtectedLayout: React.FC = (): React.ReactElement => {
	const isAuth = useAppSelector((state) => state.auth.isAuth);
	const location = useLocation();
	const { user, isUserLoading } = useAuth();

	if (isUserLoading) {
		return (
			<div className="min-h-screen flex items-center justify-center">
				<div className="animate-spin rounded-full h-8 w-8 border-b-2 border-foreground" />
			</div>
		);
	}

	return isAuth && user ? (
		<Outlet />
	) : (
		<Navigate state={{ from: location }} to="/sign-in" replace />
	);
};

export default ProtectedLayout;
